import React from "react";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";
const Experience = () => {
  return (
    <section className="experience section" id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>
      <div className="experience__container container grid">
        <div className="experience__frontend ">
          <h3>Telecom Engineering Skills</h3>
          <div className="experience__card">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                
                <h4>4G & 5G Architecture</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                
                <h4>RF Design and Simulation</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>

                <h4>Internet of Things</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>

                <h4>Antenna Design and Analysis</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>

                <h4>Signal Processing</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            {/* <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>

                <h4>React</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article> */}
          </div>
        </div>
        <div className="experience__backend ">
          <h3>Programming Skills</h3>
          <div className="experience__card">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Matlab & Simulink</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                  <h4>C++</h4>
                  <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Python </h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
